import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, Validators } from '@angular/forms';
import { Observable } from 'rxjs'
import 'rxjs/add/operator/map';

function isEmptyInputValue(value: any): boolean {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}

@Injectable()
export class NameValidators {
    constructor(
    ) {

    }

    existingObjectValidator(initialVal: string = '', serviceCall:(controlValue: string) => Observable<any>): AsyncValidatorFn {
        return (control: AbstractControl): Promise<{ [key: string]: any } | null> | Observable<{ [key: string]: any } | null> => {
            if (isEmptyInputValue(control.value)) {
                return Observable.of(null);
            } else if ('' + control.value === initialVal) {
                return Observable.of(null);
            }
            else {

                return serviceCall(control.value).map(cmps => {
                    return (cmps && cmps.length > 0) ? { 'existingName': { value: control.value } } : null;
                });
            }
        };
    }    
    
}


// WEBPACK FOOTER //
// ./src/app/exa/_validators/name.validators.ts